/**
 *   路由引入
 */
import Client   from  '@/components/client/client'
import Filter   from  '@/components/client/filter'
import ClientDetails  from  '@/components/client/clientDetails'
import StayClient     from  '@/components/client/stayClient'
import StoresNumbers  from  '@/components/client/storesNumbers'
import client360  from  '@/components/client/client360'


export default  [
    {
        path: '/Client',
        name: 'Client',
        component: Client,
        meta:{
          title:"客户信息列表"
        }
      },{
        path: '/Filter',
        name: 'Filter',
        component: Filter,
        meta:{
          title:"高级搜索"
        }
      },
      {
        path: '/ClientDetails',
        name: 'ClientDetails',
        component: ClientDetails,
        meta:{
          title:"客户详情"
        }
      },{
        path: '/StayClient',
        name: 'StayClient',
        component: StayClient,
        meta:{
          title:"待分派客户列表"
        }
      },{
        path: '/StoresNumbers',
        name: 'StoresNumbers',
        component: StoresNumbers,
        meta:{
          title:"到店人数"
        }
      },{
        path: '/client360',
        name: 'client360',
        component: client360,
        meta:{
          title:"客户360"
        }
      }
]



// WEBPACK FOOTER //
// ./src/router/clients.js